export const DESKTOP = "desktop";
export const MOBILE = "mobile";
